// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Wb6N","header":"ReportDetails_header__Uen71","title":"ReportDetails_title__3U1ZI","left":"ReportDetails_left__p4WvX"};